var StickerEditorModeManager = require('./sticker');

function BannerEditorModeManager () { this.type = 'banner'; }
BannerEditorModeManager.prototype = new StickerEditorModeManager();
module.exports = BannerEditorModeManager;
